import { footerLinks, footerNote } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="border-b border-accent-500/30">
        <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
          <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
            <div>
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-focus-3-line text-lg" />
                </span>
                <span className="font-heading text-xl font-black tracking-wide text-background-50">
                  九色<span className="text-accent-300">黑料</span>
                </span>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
                实锤、内幕与证据按事件先后归档的专题合集站，适合想查证九色黑料细节、找对应顺序的人。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {['持续更新', '按序归档', '来源对照'].map((k) => (
                  <span
                    key={k}
                    className="whitespace-nowrap rounded-full border border-accent-500/40 px-3 py-1 text-xs text-accent-200"
                  >
                    {k}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50">快速导航</h4>
              <ul className="mt-3 space-y-2">
                {footerLinks.map((l) => (
                  <li key={l.anchor}>
                    <a
                      href={l.anchor}
                      className="text-sm text-background-300 hover:text-accent-200"
                    >
                      {l.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50">检索提示</h4>
              <ul className="mt-3 space-y-2 text-sm text-background-300">
                <li>先定方向：人物 / 时段 / 题材 / 进度</li>
                <li>再看封面大图对应的合集简介</li>
                <li>必要时回看「深扒脉络」理清顺序</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-5 md:px-6">
        <p className="text-xs leading-relaxed text-background-400">{footerNote}</p>
        <p className="mt-3 flex flex-col items-start justify-between gap-2 border-t border-accent-500/20 pt-3 text-xs text-background-400 sm:flex-row sm:items-center">
          <span>© 2026 九色黑料 · 实锤 / 内幕 / 深扒专题归档</span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-focus-3-line" />
            细节深扒，持续更新中
          </span>
        </p>
      </div>
    </footer>
  );
}